const KEY  = 'fm_jwt';
const MAIL = 'fm_email';

export const getToken  = (): string | null => localStorage.getItem(KEY);
export const setToken  = (token: string, email?: string): void => {
  localStorage.setItem(KEY, token);
  if (email) localStorage.setItem(MAIL, email);
};
export const getEmail  = (): string | null => localStorage.getItem(MAIL);
export const removeToken = (): void => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(MAIL);
};